// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Head_wrapper__a_0B_","top":"Head_top__3Htkt","name":"Head_name__naon_","filters":"Head_filters__VxhF1","filtersIn":"Head_filtersIn__VNjxt"};